import { createAction, props } from '@ngrx/store';
import { DateTime } from 'luxon';
import { Account } from '../models/account';

const namespace = '[Accounts]';

export const PLAccountsSuccess = createAction(
  `${namespace} Accounts Success`,
  props<{
    account?: Account;
  }>()
);
export const PLAccountsPending = createAction(`${namespace} Accounts Pending`);
export const PLAccountsError = createAction(
  `${namespace} Accounts Error`,
  props<{ error: unknown }>()
);
export const PLFetchAccounts = createAction(
  `${namespace} FetchAccounts`,
  props<{ accountUuid?: string }>()
);
export const PLExtendAccountDeactivation = createAction(
  `${namespace} Extend Account Deactivation`,
  props<{ accountUuid: string; date: DateTime }>()
);
